import logo from './logo.svg';

import './index.scss';
import './App.scss';

import AppRouter from './AppRouter'

import React, { Component } from 'react';
import { render } from 'react-dom';

class App extends Component {
  render = () => {
    return (  
       <AppRouter/>
    );
  }
}



export default App;
